var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-container"},[_vm._m(0),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"msg"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-bg img-cover"},[_c('img',{attrs:{"src":require("../../assets/images/login-bg.png")}})])
}]

export { render, staticRenderFns }